import React, { Fragment } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { MainContainer, MainTitle, TitleContainer, ColumnContainer, Column, RateInput, MainForm, MainFormContent, TextInput, TextAreaInput, ButtonsRow, MainButton, Divider, DateInput, CheckboxInput, HeadSeo } from '@beacharound/beacharound-ui';

import { getBeach } from "../../api/beach";
import { getHotel } from '../../api/hotels';
import { createReview } from '../../api/reviews';
import { useUser } from '../../contexts/user';
import { getPlaceholderImage } from '../../helpers/images/getPlaceholderImage';

export default function NewReview({match, history}) {

    const { hotelSlug, beachSlug } = match.params;

    let getActivityFunction, reviewedType, activitySlug, reviewedUrl;

    if(beachSlug) {
        reviewedType = "beaches";
        reviewedUrl = "spiagge";
        activitySlug = beachSlug;
        getActivityFunction = () => {
            return getBeach({ slug: beachSlug })
        };
    }

    if(hotelSlug) {
        reviewedType = "hotels";
        reviewedUrl = "hotel";
        activitySlug = hotelSlug;
        getActivityFunction = () => {
            return getHotel({ slug: hotelSlug });
        };
    }

    const { data: activity } = useQuery([reviewedType, activitySlug], getActivityFunction)

    const { user } = useUser();

    const cache = useQueryClient();

    const {mutate: create, status } = useMutation(createReview, {
        onSuccess(data, variables) {
            cache.invalidateQueries([variables.reviewedType, variables.activitySlug])
            return history.push(match.url.replace('nuova','grazie'))
        },
    });

    async function saveReview(data) {
        try {
            let payload = {
                ...data,
                reviewed: activity._id,
                reviewedType,
            };

            if(data.firstName && data.lastName) {
                payload = {
                    ...payload,
                    reviewer: {
                        firstName: data.firstName,
                        lastName: data.lastName
                    }
                }
            }
            await create({
                data: payload
            });
        } catch(error) {
            console.log(error);
        }
    }

    const constraints = {
        firstName: { presence: !user && { message: "^Campo obbligatorio"}},
        lastName: { presence: !user && { message: "^Campo obbligatorio"}},
        vote: { presence: { message: "^Campo obbligatorio"}},
        visitedAt: { presence: { message: "^Campo obbligatorio"}},
        title: { presence: { message: "^Campo obbligatorio"}},
        description: { presence: { message: "^Campo obbligatorio"}},
        terms: { presence: { message: "^Campo obbligatorio"}},
    }

    return (
        <Fragment>
            <MainContainer>

                <HeadSeo
                    title={[`Scrivi una nuova recensione per ${activity?.name}`]}
                    name={activity?.name}
                    descriptionFull={activity?.description}
                    description={`Scrivi una nuova recensione per ${activity?.name}`}
                    type={"LocalBusiness"}
                    image={activity?.cover || getPlaceholderImage("beaches", activity)}
                />

                <TitleContainer>
                    <MainTitle
                        text={`Scrivi una nuova recensione per <strong>${activity?.name}</strong>`}
                    />
                </TitleContainer>

                <ColumnContainer>
                    <Column>
                        <MainForm onSubmit={saveReview} constraints={constraints}>
                            <MainFormContent flex>
                                {!user &&
                                    <Fragment>
                                        <TextInput
                                            name="firstName"
                                            label="Il tuo nome"
                                            half
                                        />
                                        <TextInput
                                            name="lastName"
                                            label="Il tuo cognome"
                                            half
                                        />
                                    </Fragment>
                                }
                                <RateInput
                                    name="vote"
                                    label="Dai un voto alla tua esperienza?"
                                    half
                                />
                                <DateInput
                                    name="visitedAt"
                                    label="Quando ci sei stato?"
                                    maxDate={new Date()}
                                    half
                                />
                                <TextInput
                                    name="title"
                                    label="Dai un titolo alla tua recensione"
                                />
                                <TextAreaInput
                                    name="description"
                                    label="Scrivi la tua recensione"
                                />
                                <CheckboxInput
                                    name="terms"
                                    label="Apprendo che in caso di pubblicazione di contenuti contrari alla normativa vigente e/o che presentino profili di rilevanza penale, Beacharound.com si riserva il diritto di cancellare questa recensione e di segnalare l’utente alle competenti Autorità."
                                />
                            </MainFormContent>

                            <Divider />

                            <ButtonsRow fill>
                                <MainButton
                                    border
                                    text="Annulla"
                                    action={() => history.push(`/${reviewedUrl}/${activitySlug}`)}
                                />
                                <MainButton
                                    submit
                                    text="Invia recensione"
                                    status={status}
                                />
                            </ButtonsRow>
                        </MainForm>
                    </Column>
                </ColumnContainer>
            </MainContainer>
        </Fragment>
    );
}